import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SvgIcon.module.scss';
import {capitalize} from "presentation/common/helpers/utils";

const SvgIcon = React.forwardRef(function SvgIcon(props, ref) {
  const {
    children,
    fontSize = 'default',
    htmlColor,
    color = 'default',
    className,
    component: Component = 'svg',
    titleAccess,
    viewBox = '0 0 24 24',
    ...other
  } = props;

  const classes = {
    'colorDefault': 'primary',
    'colorPrimary': 'primary',
    'colorWhite': 'white',
    'colorError': 'error',
    'colorWarning': 'warning',
    'colorDisabled': 'black',
    'fontDefault': styles.sizeDefault,
    'fontSmall': styles.sizeSmall,
    'fontXSmall': styles.sizeXSmall,
    'fontLarge': styles.sizeLarge,
    'fontXxLarge': styles.xxLarge,
    'fontXxxLarge': styles.xxxLarge,
  };

  const applyFontSize = classes[`font${capitalize(fontSize)}`] || fontSize;

  return (
    <Component
      className={
        clsx(
          [styles.svgIcon],
          [classes[`color${capitalize(color)}`]],
          applyFontSize,
          className
        )
      }
      focusable="false"
      viewBox={viewBox}
      color={htmlColor}
      aria-hidden={titleAccess ? undefined : true}
      role={titleAccess ? 'img' : undefined}
      ref={ref}
      {...other}>
      {children}
      {titleAccess ? <title>{titleAccess}</title> : null}
    </Component>
  );
});

SvgIcon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf(['disabled', 'error', 'default', 'primary', 'white']),
  component: PropTypes.elementType,
  fontSize: PropTypes.any,
  htmlColor: PropTypes.string,
  shapeRendering: PropTypes.string,
  titleAccess: PropTypes.string,
  viewBox: PropTypes.string,
};

export default SvgIcon;
